<template>
    <v-list nav dense >
        <v-list-item-group>
        <v-list-group  >
            <template v-slot:activator > 
                <v-list-item-icon >
                    <v-icon>mdi-decagram-outline</v-icon>

                </v-list-item-icon>
                <v-list-item-content >
                    <v-list-item-title>Configuración</v-list-item-title>
                </v-list-item-content>
            </template>
            
            <div class="ml-5">
             <router-link
                class="menu-item"
                to="Persona"
                active-class="active-link"
                v-if="persona.Rol == 1"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Persona")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <router-link
                class="menu-item"
                to="Rol"
                active-class="active-link"
                v-if="persona.Rol == 1"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-key</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Rol")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>


              <router-link
                class="menu-item"
                to="UnidadAcademica"
                active-class="active-link"
                v-if="persona.Rol == 1"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-school</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.UnidadAcademica")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <router-link
                class="menu-item"
                to="Pais"
                active-class="active-link"
                v-if="persona.Rol == 1 || persona.Rol == 2 "
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>fa fa-globe</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("País")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <router-link
                class="menu-item"
                to="Ciudad"
                active-class="active-link"
                v-if="persona.Rol == 1 || persona.Rol == 2 "
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>fa fa-asterisk</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("Ciudad")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <router-link
                class="menu-item"
                to="TipoConvenio"
                active-class="active-link"
                v-if="persona.Rol == 1 "
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>fa fa-certificate</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("Tipo de Convenio")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>


            <router-link
                class="menu-item"
                to="TipoInstitucion"
                active-class="active-link"
                v-if="persona.Rol == 1 "
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>fa fa-certificate</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Tipo Institucion</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>
            </div>

        </v-list-group>

        
            <router-link
                class="menu-item"
                to="/"
                active-class="active-link"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>fa fa-home</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("Inicio")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>
            
            <!-- <router-link
                class="menu-item"
                to="Persona"
                active-class="active-link"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Persona")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->

            <!-- <router-link
                class="menu-item"
                to="UnidadAcademica"
                active-class="active-link"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-school</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.UnidadAcademica")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->

            <!-- <router-link
                class="menu-item"
                to="Rol"
                active-class="active-link"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-key</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Rol")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->

            <router-link
                class="menu-item"
                to="Profile"
                active-class="active-link"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-account-circle</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Profile")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>


            <!-- <router-link
                class="menu-item"
                to="Pais"
                active-class="active-link"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>fa fa-globe</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("País")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->


            <!-- <router-link
                class="menu-item"
                to="Ciudad"
                active-class="active-link"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>fa fa-asterisk</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("Ciudad")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->


            <!-- <router-link
                class="menu-item"
                to="TipoConvenio"
                active-class="active-link"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>fa fa-certificate</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("Tipo de Convenio")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->

             <!-- <router-link
                class="menu-item"
                to="TipoInstitucion"
                active-class="active-link"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>fa fa-certificate</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Tipo Institucion</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->



            <!-- <router-link
                class="menu-item"
                to="Institucion"
                active-class="active-link"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>fa fa-university</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("Institución")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->


            <router-link
                class="menu-item"
                to="Convenio"
                active-class="active-link"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-note-text</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Registro Convenios</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <router-link
                class="menu-item"
                to="Reportes"
                active-class="active-link"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-note</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Reportes</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>


            <router-link
                class="menu-item"
                to="Manual"
                active-class="active-link"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-eye</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Manual</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <!-- <router-link
                class="menu-item"
                to="TipoReporte"
                active-class="active-link"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-note-text</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.TipoReporte")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->
            


            <!-- <router-link
                class="menu-item"
                to="TipoReporteVer"
                active-class="active-link"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-file-chart</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.TipoReporteVer")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->

        </v-list-item-group>
    </v-list>
</template>

<script>
export default {
    name: "MenuVuetify",
    data() {
        return {
            msg: "MenuVuetify",
            persona:{}

        };
    },
     mounted() {
        this.persona = JSON.parse(localStorage.getItem("persona"));
    },
};
</script>
